import React from "react";
import { useParams } from "react-router-dom";
import AuditTrailsTable from "../../common/AuditTrailsTable";
import {
    GetLtiIntegrationAuditTrail,
    GetLtiIntegrationAuditTrailFilters,
} from "../../../services/LtiIntegrationService";

/**
 * Renders LTI integrations audit trail, scoped to one integration when opened from details.
 * @returns {JSX.Element} Audit trail table
 */
const AuditTrail = () => {
    const { id } = useParams();
    const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

    /**
     * Builds the details page URL for an audit trail resource.
     * @param {string|number} resourceId Integration id from the audit row.
     * @returns {string} Details route
     */
    const handleRedirect = (resourceId) => {
        return `/administration/integrations/open/${resourceId}/details`;
    };

    return (
        <AuditTrailsTable
            apiFunction={GetLtiIntegrationAuditTrail}
            filterArrApi={GetLtiIntegrationAuditTrailFilters}
            columnsToShow={columnsToShow}
            exportFileName="LTI_Integrations_Audit_Trail"
            resourceNameRedirect={handleRedirect}
            isShowingResourceTypeFilter
            isResourceNameShown={true}
            actionId={id}
            apiParams={id ? { action_id: id } : {}}
        />
    );
};

export default AuditTrail;
